import { projectRequest } from 'store/utils/request';

export const getFilesRequest = async (params = {}) => {
  try {
    return await projectRequest.get(`/test_sets/`, {
      params: {
        ...params,
        archived: false,
        ordering: '-updated_at',
        page: params.page ?? 1,
        size: params.size ?? 400, // This is the maximum results the api returns.
      },
    });
  } catch (error) {
    throw error;
  }
};

export const getFileRequest = async id => {
  try {
    return await projectRequest.get(`/test_sets/${id}/`);
  } catch (error) {
    throw error;
  }
};

export const addFileRequest = async data => {
  try {
    return await projectRequest.post(`/test_sets/`, data);
  } catch (error) {
    throw error;
  }
};

export const importTestSetRequest = async (file, config = {}) => {
  try {
    const data = new FormData();
    data.append('entries_file', file, file.name);
    data.append('name', file.name);

    const defaultConfig = {
      headers: {
        'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
      },
      timeout: 60000,
      ...config,
    };

    return await projectRequest.post(`/test_sets/import/`, data, defaultConfig);
  } catch (error) {
    throw error;
  }
};

export const updateFileRequest = async (testSetId, data) => {
  try {
    return await projectRequest.put(`/test_sets/${testSetId}/`, data);
  } catch (error) {
    throw error;
  }
};

export const deleteFileRequest = async id => {
  try {
    return await projectRequest.delete(`/test_sets/${id}/`);
  } catch (error) {
    throw error;
  }
};

export const updateBlobRequest = async (path, data) => {
  try {
    return await projectRequest.put(`/nlu_resources/blobs/${path}/`, data);
  } catch (error) {
    throw error;
  }
};

export const downloadTestSetRequest = async id => {
  try {
    return await projectRequest.get(`/test_sets/${id}/download/`, {
      timeout: 60000,
    });
  } catch (error) {
    throw error;
  }
};

export const exportFilesRequest = async data => {
  try {
    return await projectRequest.post(`/test_sets/export/`, data, {
      responseType: 'blob',
      timeout: 60000,
    });
  } catch (error) {
    throw error;
  }
};

export const replaceTestSetRequest = async (id, data) => {
  try {
    return await projectRequest.put(`/test_sets/${id}/replace/`, data);
  } catch (error) {
    throw error;
  }
};

export const deleteFilesRequest = async data => {
  try {
    return await projectRequest.post(`/test_sets/multi/`, data);
  } catch (error) {
    throw error;
  }
};
